import { useTranslation } from 'react-i18next';
import { CalendarBlankIcon } from '@phosphor-icons/react';
import type { TaskDto } from '@monorepo/shared';
import { formatDueDate, getDueDateDelay } from './taskDisplay';

interface TaskDueDateCellProps {
  task: TaskDto;
}

export const TaskDueDateCell = ({ task }: TaskDueDateCellProps) => {
  const { t } = useTranslation();
  const delay = getDueDateDelay(task.dueDate, task.status);

  return (
    <div className="flex flex-col items-end gap-0.5 lg:items-start">
      <span className="inline-flex items-center gap-2 text-sm text-gray-600">
        <CalendarBlankIcon size={16} className="text-gray-400" />
        {formatDueDate(task.dueDate)}
      </span>

      {delay && (
        <span className={`text-xs font-medium ${delay.className}`}>
          {t(delay.key, { count: delay.count })}
        </span>
      )}
    </div>
  );
};
